export const isProduction = process.env.NODE_ENV === 'production';
export const domain = process.env.REACT_APP_API_URL || "https://api2.wewowcpa.online";
export const PRICE_PER_HOUR = Number(process.env.REACT_APP_PRICE_PER_HOUR || 10);